module.exports = __webpack_public_path__ + "static/media/dark-circles.5b2759d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/instore/icons/dark-circles.svg
// module id = 148
// module chunks = 0